/**
 * Ekran ayarlarındaki depo/stok görünürlük yapılandırmasına göre
 * bir ürün için doğru depo ID'sini belirler.
 *
 * Öncelik sırası:
 * 1. products mapping: ürün ID doğrudan bir depo-kategori altında tanımlıysa
 * 2. categories mapping: ürünün categoryId'si bir depo altında tanımlıysa
 * 3. warehouses[0]: fallback olarak ilk depo
 */
export function resolveWarehouseId(
  productId: string,
  categoryId: string | undefined | null,
  screenSettings: any
): string | null {
  const stockVisibility =
    screenSettings?.stockVisibility || screenSettings?.StockVisibilityJson;

  if (!stockVisibility) return null;

  const warehouses: string[] = stockVisibility.warehouses || [];
  const categoriesMap: Record<string, string[]> = stockVisibility.categories || {};
  const productsMap: Record<string, Record<string, string[]>> =
    stockVisibility.products || {};

  // 1) Ürün ID'si üzerinden doğrudan eşleme
  for (const whId of warehouses) {
    const categoriesForWh = productsMap[whId];
    if (!categoriesForWh) continue;
    for (const catId of Object.keys(categoriesForWh)) {
      const productIds = categoriesForWh[catId];
      if (productIds && productIds.includes(productId)) {
        return whId;
      }
    }
  }

  // 2) Kategori ID'si üzerinden eşleme
  if (categoryId) {
    for (const whId of warehouses) {
      const categoryIds = categoriesMap[whId];
      if (categoryIds && categoryIds.includes(categoryId)) {
        return whId;
      }
    }
  }

  // 3) Fallback: ilk depo
  return warehouses[0] || null;
}
